'use client';
import React, { Suspense } from 'react';
import { ConnatixLivestream } from './ConnatixLivestream';

const Block = React.lazy(() => import('../Block').then(module => ({ default: module.Block })));

interface ConnatixVideoProps {
  attrs?: {
    data?: {
      non_live_widget: unknown;
    };
  };
  fallback?: React.ReactNode;
}

export const ConnatixLiveBlock: React.FC<ConnatixVideoProps> = ({ attrs, fallback }) => {
  const nonLiveWidget = attrs?.data?.non_live_widget;

  return (
    <ConnatixLivestream
      fallback={fallback}
      nonLive={
        nonLiveWidget ? (
          <Suspense fallback={null}>
            <Block block={nonLiveWidget} />
          </Suspense>
        ) : undefined
      }
    />
  );
};
